// extracted by mini-css-extract-plugin
export var fullWidthButton = "_sg-0";